import { render } from "./CollectionsByFolder.vue?vue&type=template&id=6ffb0d84"
import script from "./CollectionsByFolder.vue?vue&type=script&lang=js"
export * from "./CollectionsByFolder.vue?vue&type=script&lang=js"

import "./CollectionsByFolder.vue?vue&type=style&index=0&id=6ffb0d84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__